module.exports = __webpack_public_path__ + "img/map.2a5c6a26.png";